/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {BundleSettlementsTableComponent} from './bundle-settlements-table.component';
import {TableModule} from '../../shared/table/table.module';
import {BundleSettlementsDetailModule} from '../bundle-settlements-detail/bundle-settlements-detail.module';
import {CommonModule} from '@angular/common';

@NgModule({
    exports: [BundleSettlementsTableComponent],
    imports: [TableModule, BundleSettlementsDetailModule, CommonModule],
    declarations: [BundleSettlementsTableComponent]
})

export class BundleSettlementsTableModule {

}
